<div style="display: flex; flex-direction: column; height: 100%; justify-content: center; align-items: center; text-align: center;">
  <p style="color: rgb(0, 199, 0); font-size: 24px; ">SIGN UP SUCCESSFUL</p>
  <p style="color: black; font-size: 16px; padding: 16px;">Thank you for signing up with Clear Access. Your order has been successfully submitted. Please check your emails for further information.</p>
</div>
